<template>
  <div>
    <CCard>
      <CCardHeader>
        <h2 class="d-flex align-items-center mb-5">
          <span>部署管理</span>
        </h2>
        <CRow>
          <CCol sm="12" md="6" lg="4" xl="3">
            <CCard color="info"
                  class="text-white card-select mb-3"
                  @click="openOrgChartModal">
              <CCardBody class="py-3 text-center">
                <div class="font-weight-bold">組織図</div>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
        <span v-if="canManage" class="card-header-actions">
          <router-link :to="{ name: registerTop }">
            <button class="btn btn-primary">新規登録</button>
          </router-link>
        </span>
      </CCardHeader>
      <CCardBody>
        <CRow v-if="errors.length">
          <ul>
            <li style="color: red" v-for="error in errors" :key="error">
              {{ error }}
            </li>
          </ul>
        </CRow>

        <div class="table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>部署名</th>
                <th>部署コード</th>
                <th>親部署</th>
                <th>部署長</th>
                <th v-if="canManage" style="width: 120px;"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in items" :key="item.id">
                <td>
                  <router-link v-if="canManage" :to="{ name: info, params: { id: item.id } }">
                    {{ item.name }}
                  </router-link>
                  <span v-else>
                    {{ item.name }}
                  </span>
                </td>
                <td>{{ item.code }}</td>
                <td>{{ item.parent_name }}</td>
                <td>{{ item.head_user_name }}</td>
                <td v-if="canManage">
                  <button
                    v-on:click="openModal(item, index)"
                    class="btn btn-danger"
                  >
                    無効
                  </button>
                  <DeleteModal
                    :val="postItem"
                    :loading="loading"
                    v-show="showModal"
                    @delete="deleteDepartment"
                    @close="closeModal"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex justify-content-center">
          <VPagination
            v-model="currentPage"
            :click-handler="changePage"
            :page-count="totalPages"
            :force-ellipses="true"
            :container-class="'pagination'"
            :page-class="'page-item'"
            :prev-text="'<'"
            :next-text="'>'"
            :prev-link-class="'page-link'"
            :next-link-class="'page-link'"
            :page-link-class="'page-link'"
            :class-prefix="'pagination'"
          />
        </div>
        <OrganizationChartModal
        :items="orgItems"
        :loading="orgLoading"
        v-show="showOrgModal"
        @close="closeOrgChartModal"
        />
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import ConstList from './../ConstList'
import DeleteModal from './DeleteModal'
import OrganizationChartModal from './OrganizationChartModal'
import axios from 'axios'
import VPagination from 'vuejs-paginate'

export default {
  name: 'DepartmentList',
  components: {
    DeleteModal,
    OrganizationChartModal,
    VPagination
  },
  data() {
    return {
        showModal: false,
        showOrgModal: false,
        postItem: '',
        items: [],
        errors: [],
        registerTop: '',
        info: '',
        currentPage: 1,
        pageSize: 10,
        totalPages: 1,
        submit_flg: false,
        loading: false,
        orgLoading: false,
        level: null
    }
  },
  computed: {
    canManage: function () {
      const n = Number(this.level)
      return Number.isFinite(n) && n > 8
    }
  },
  created() {
    this.registerTop = ConstList.DEPARTMENT_REGISTER_TOP
    this.info = ConstList.DEPARTMENT_INFO_TOP
  },
  mounted: function () {
    this.callList()
    this.fetchTotalPages()
  },
  methods: {
    callList: function () {
      axios
        .get(process.env.VUE_APP_API_ORIGIN + '/departments', {
          params: {
            currentPage: this.currentPage,
            pageSize: this.pageSize
          }
        })
        .then((response) => {
          this.items = response.data
          this.level = (this.items && this.items.length) ? this.items[0].level : this.level
          this.errors = []
          if (this.items.length === 0 && ConstList.EMPTY) {
            this.errors.push(ConstList.EMPTY)
          }
        })
        .catch((error) => {
          axios
            .get(`${process.env.VUE_APP_API_ORIGIN}/error/frontError/${encodeURIComponent(error.message || String(error))}`)
            .then(() => {
              alert(ConstList.SYSTEM_ERROR)
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR)
            })
        })
    },
    fetchTotalPages: function () {
      axios
        .get(process.env.VUE_APP_API_ORIGIN + '/departments/count')
        .then((response) => {
          const totalCount = response.data
          this.totalPages = Math.ceil(totalCount / this.pageSize) || 1
        })
        .catch((error) => {
          axios
            .get(`${process.env.VUE_APP_API_ORIGIN}/error/frontError/${encodeURIComponent(error.message || String(error))}`)
            .then(() => {
              alert(ConstList.SYSTEM_ERROR)
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR)
            })
        })
    },
    changePage: function (page) {
      this.currentPage = page
      this.callList()
    },
    openModal: function (item) {
      if (this.submit_flg) return
      this.postItem = item
      this.showModal = true
    },
    closeModal: function () {
      this.showModal = false
    },
    deleteDepartment: function () {
      this.loading = true
      const params = new URLSearchParams()
      params.append('id', this.postItem.id)

      axios
        .post(process.env.VUE_APP_API_ORIGIN + '/departments/delete', params)
        .then(() => {
          alert(ConstList.DELETE_MESSAGE)
          this.showModal = false
          this.callList()
          this.fetchTotalPages()
        })
        .catch((error) => {
          axios
            .get(`${process.env.VUE_APP_API_ORIGIN}/error/frontError/${encodeURIComponent(error.message || String(error))}`)
            .then(() => {
              alert(ConstList.SYSTEM_ERROR)
            })
            .catch(() => {
              alert(ConstList.SYSTEM_COMMUNICATION_ERROR)
            })
        })
        .finally(() => {
          this.loading = false
        })
    },
    numberOrZero: function (v) {
      const n = Number(v)
      return Number.isFinite(n) ? n : 0
    },
    openOrgChartModal: function () {
    this.showOrgModal = true
    this.fetchOrgItems()
    },
    closeOrgChartModal: function () {
    this.showOrgModal = false
    },
    fetchOrgItems: function () {
    this.orgLoading = true

    axios
        .get(process.env.VUE_APP_API_ORIGIN + '/departments/count')
        .then((countResponse) => {
        const totalCount = Number(countResponse.data)
        const allCount = Number.isFinite(totalCount) && totalCount > 0 ? totalCount : 1

        return axios.get(process.env.VUE_APP_API_ORIGIN + '/departments', {
            params: {
            currentPage: 1,
            pageSize: allCount
            }
        })
        })
        .then((response) => {
        this.orgItems = Array.isArray(response.data) ? response.data : []
        this.level = (this.orgItems && this.orgItems.length) ? this.orgItems[0].level : this.level
        })
        .catch((error) => {
        axios
            .get(`${process.env.VUE_APP_API_ORIGIN}/error/frontError/${encodeURIComponent(error.message || String(error))}`)
            .then(() => {
            alert(ConstList.SYSTEM_ERROR)
            })
            .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR)
            })
        })
        .finally(() => {
        this.orgLoading = false
        })
    }
  }
}
</script>

<style scoped>
.table td.position-right,
.table th.position-right {
  text-align: right !important;
  padding-right: 10px;
}
td {
  vertical-align: middle;
  white-space: nowrap;
}
</style>
